// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login__\\+H1JP {
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #22272a;
  color: white;
}

.p-inputtext:enabled:hover {
  border-color: #ced4da;
}

.p-inputtext:enabled:focus {
  border-color: #883cae;
  box-shadow: 0 0 0 .2rem #883cae80;
  outline: 0 none;
  outline-offset: 0;
}

.Login_wrapper__ZcalN {
  width: 320px;
  background-color: var(--branded-gray);
  padding: 45px;
  color: black;
  border-radius: 5px;
  margin: 30px 0 15px;
}

.Login_wrapper__ZcalN h2 {
  text-align: center;
  margin-top: 0;
}

.Login_err__cX9WN {
  margin-bottom: 30px;
}

.Login_form__kFnwI {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Login_inpuField__G7EDZ {
  display: flex;
  flex-direction: column;
}

.Login_btn__pALc8 {
  background-color: var(--branded-purple);
  border-color: var(--branded-purple);
}

.Login_btn__pALc8:hover {
  background-color: var(--branded-action-purple) !important;
  border-color: var(--branded-action-purple) !important;
}

.Login_btnPassword__7guA1 {
  border: none;
  text-align: center;
  margin: 20px auto;
  display: block;
  text-decoration: underline;
  color: blue;
}

.Login_password-reset-prompt__vitp- {
  display: inline-block;
  margin-top: -30px;
  margin-bottom: 10px;
  color: rgb(224 60 60);
}

.Login_plain-text-link__hf5L3 {
  background: none;
  border: none !important;
  padding: 0;
  color: #8467ae;
  font-size: 1rem;
  cursor: pointer;
  text-align: center;
  display: block;
  width: 100%;
  text-decoration: underline;
  transition: transform 0.1s ease;
}

.Login_plain-text-link__hf5L3:hover {
  color: #542296;
}

.Login_plain-text-link__hf5L3:focus {
  outline: none;
}

.Login_plain-text-link__hf5L3:active {
  transform: scale(0.95);
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,yDAAyD;EACzD,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".login {\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: #22272a;\n  color: white;\n}\n\n:global(.p-inputtext:enabled:hover) {\n  border-color: #ced4da;\n}\n\n:global(.p-inputtext:enabled:focus) {\n  border-color: #883cae;\n  box-shadow: 0 0 0 .2rem #883cae80;\n  outline: 0 none;\n  outline-offset: 0;\n}\n\n.wrapper {\n  width: 320px;\n  background-color: var(--branded-gray);\n  padding: 45px;\n  color: black;\n  border-radius: 5px;\n  margin: 30px 0 15px;\n}\n\n.wrapper h2 {\n  text-align: center;\n  margin-top: 0;\n}\n\n.err {\n  margin-bottom: 30px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.inpuField {\n  display: flex;\n  flex-direction: column;\n}\n\n.btn {\n  background-color: var(--branded-purple);\n  border-color: var(--branded-purple);\n}\n\n.btn:hover {\n  background-color: var(--branded-action-purple) !important;\n  border-color: var(--branded-action-purple) !important;\n}\n\n.btnPassword {\n  border: none;\n  text-align: center;\n  margin: 20px auto;\n  display: block;\n  text-decoration: underline;\n  color: blue;\n}\n\n.password-reset-prompt {\n  display: inline-block;\n  margin-top: -30px;\n  margin-bottom: 10px;\n  color: rgb(224 60 60);\n}\n\n.plain-text-link {\n  background: none;\n  border: none !important;\n  padding: 0;\n  color: #8467ae;\n  font-size: 1rem;\n  cursor: pointer;\n  text-align: center;\n  display: block;\n  width: 100%;\n  text-decoration: underline;\n  transition: transform 0.1s ease;\n}\n\n.plain-text-link:hover {\n  color: #542296;\n}\n\n.plain-text-link:focus {\n  outline: none;\n}\n\n.plain-text-link:active {\n  transform: scale(0.95);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `Login_login__+H1JP`,
	"wrapper": `Login_wrapper__ZcalN`,
	"err": `Login_err__cX9WN`,
	"form": `Login_form__kFnwI`,
	"inpuField": `Login_inpuField__G7EDZ`,
	"btn": `Login_btn__pALc8`,
	"btnPassword": `Login_btnPassword__7guA1`,
	"password-reset-prompt": `Login_password-reset-prompt__vitp-`,
	"plain-text-link": `Login_plain-text-link__hf5L3`
};
export default ___CSS_LOADER_EXPORT___;
